/**
 * Creates a message listener for USAePay payment card iframe events.
 * Query the iframe element fresh on each message event to avoid stale references.
 */
export function createUSAePayMessageListener(eventType: any, response: any) {
  return (event: any) => {
    const paymentCardiFrame = document.getElementById('paymentCardIFrame');

    if (event.source === (paymentCardiFrame as any)?.contentWindow) {
      if (typeof event.data === 'string') {
        const msg = event.data.split('::');

        if (msg[0] === eventType) {
          response(msg[1]);
        }
      }
    }
  };
}
